import { getRequestsPageListApi } from '../api/requests';
import {
    paginatedRequestsActions,
    paginatedRequestsSelector,
  } from '../redux/slicers/admin/paginatedRequests';
import { useThumbnailCardDataList } from './useDataList';

export const useRequests = ({
  requestParams,
  filterByKey,
  defaultBrands,
  defaultSort,
  useGlobalSearch,
  defaultCreatedBy,
  modelType,
} = {}) => {
  const data = useThumbnailCardDataList({
    selector: paginatedRequestsSelector,
    resetAction: paginatedRequestsActions.resetList,
    getAction: getRequestsPageListApi,
    requestParams,
    filterByKey,
    defaultSort,
    useGlobalFilter: true,
    defaultBrands,
    useGlobalSearch,
    defaultCreatedBy,
    modelType,
  });

  return data;
};
